<wl-rich-text-wrapper [field]="{ value: disclaimer }">
  <div class="disclaimer p-2 mt-3" wlCSCapture></div>
</wl-rich-text-wrapper>
